<template>
  <div class="comments-list-area">
      <ul class="comments-list" v-if="postIdUser > 0">
        <li class="list-item" v-for="(comment, index) in myPostValues.comments" :key="index" >
          <i :class="{'icon-user': isUser(comment.user.role) , 'icon-admin': isAdmin(comment.user.role)}"></i>
          <div class="comments-inform">
            <p class="inform">{{comment.user.name}}<span class="date">{{comment.createdDate}}</span></p>
            <p class="txt" v-html="comment.content"></p>
          </div>
        </li>
      </ul>
      <ul class="comments-list" v-if="postIdAdmin > 0">
        <li class="list-item" v-for="(comment, index) in adminPostValues.comments" :key="index" >
          <i :class="{'icon-user': isUser(comment.user.role) , 'icon-admin': isAdmin(comment.user.role)}"></i>
          <div class="comments-inform">
            <p class="inform">{{comment.user.name}}<span class="date">{{comment.createdDate}}</span>
              <button type="button" class="comment-mod-btn" v-if="comment.canUpdateComment && isPrint === 'false'" @click="commentMody(comment)">수정</button>
            </p>
            <p class="txt" v-html="comment.content" v-if="comment.id !== commentId"></p>
            <!-- 댓글 수정 area -->
            <div class="comments-input-area" v-if="comment.id === commentId">
              <div class="comments-input">
                  <textarea name="comments-area" id="comments-area" cols="20" rows="10" class="default-textarea" v-model="content"></textarea>
                  <label for="comments-area" class="blind">내용</label>
              </div>
              <div class="comments-btn">
                  <button type="button" class="default-btn" @click="btnModify()">수정</button>
              </div>
            </div>
            <!-- 댓글 수정 area -->
          </div>
        </li>
      </ul>
  </div>
</template>
<style lang="scss" scoped>
@import '../css/admin.scss';
@import '../css/sub.scss';
</style>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'CommentsList',
  props: ['isPrint'],
  data () {
    return {
      content: '',
      commentId: ''
    }
  },
  methods: {
    isUser (value) {
      if (value === 'ROLE_USER') {
        return true
      } else {
        return false
      }
    },
    isAdmin (value) {
      if (value === 'ROLE_ADMIN') {
        return true
      } else {
        return false
      }
    },
    commentMody (comment) {
      if (this.commentId === comment.id) {
        this.commentId = ''
        this.content = ''
      } else {
        this.commentId = comment.id
        this.content = comment.content.split('<br>').join('\n')
      }
    },
    btnModify () {
      if (!confirm('수정하시겠습니까?')) {
        return
      }
      const params = {
        'content': this.content.split('\n').join('<br>'),
        'commentId': this.commentId,
        'method': 'PATCH'
      }
      this.$store.dispatch('apiAdminPostsComment', params)
      this.commentId = ''
      this.content = ''
    }
  },
  computed: {
    ...mapGetters({
      myPostValues: 'getMyPostValues',
      adminPostValues: 'getAdminPostVal',
      postIdAdmin: 'getPostIdAdmin',
      postIdUser: 'getPostIdUser'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CommentsList.vue